<div class="col-md-12 info-register" style="background-color: rgba(74,0,229,0.39)">
  <img class="logo-register" src="assets/logosemfundo.svg" alt="Logo">
  <div class="textos-info">
    Comece a gerenciar seus clientes com eficiência, clareza e foco nos resultados.
  </div>
  <div class="imagem">
    <img src="assets/representantecomercial.png" alt="representante comercial" class="img-fluid">
  </div>

  <div class="textos-titulo">
    Cadastre-se agora e diga adeus às planilhas confusas, anotações espalhadas e à desorganização que atrasa suas vendas.
  </div>
  <div class="textos-centralizados" >
    <i class="fa fa-check-circle-o" style="color: #2E5266 !important"></i> Organiza seus contatos
  </div>
  <div class="textos-centralizados">
    <i class="fa fa-check-circle-o" style="color: #2E5266 !important"></i> Controle sobre seu funil de vendas
  </div>
  <div class="textos-centralizados">
    <i class="fa fa-check-circle-o" style="color: #2E5266 !important"></i> Aumenta sua produtividade
  </div>
  <div class="textos-centralizados">
    <i class="fa fa-check-circle-o" style="color: #2E5266 !important"></i> Acompanhe oportunidades e resultados
  </div>
</div>
